import { useEffect, useState } from 'react';

/** Matches Tailwind's `md` breakpoint so behaviour can differ just below it. */
const BELOW_MD_QUERY = '(max-width: 767.98px)';

/**
 * True while the viewport is below `md`. SSR-safe: starts false and resolves on
 * mount, so below-md variants apply purely client-side and never mismatch
 * hydration (the bulk-enquiry surfaces only appear after client interaction
 * anyway).
 */
export const useIsBelowMd = (): boolean => {
    const [belowMd, setBelowMd] = useState(false);
    useEffect(() => {
        const query = window.matchMedia(BELOW_MD_QUERY);
        setBelowMd(query.matches);
        const onChange = () => setBelowMd(query.matches);
        query.addEventListener('change', onChange);
        return () => query.removeEventListener('change', onChange);
    }, []);
    return belowMd;
};
